export default __webpack_public_path__ + "static/media/2B_360_2_alt.c495ceee.jpg";